<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormPanel
          :initial="primaryMenuLinkChild.attributes"
          headline="Edit Primary Menu Link Child"
          :errors="errors"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/PrimaryMenuLinkChildren/Panels/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {LoadingContainer, FormPanel},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      primaryMenuLinkChild: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/primary-menu-link-children/' + this.$route.params.primaryMenuLinkChildId).then(response => {
        this.primaryMenuLinkChild = response.data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/primary-menu-link-children/' + this.$route.params.primaryMenuLinkChildId, data)
          .then(() => {
            notify.success('The primary menu link child was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/primary-menu-links/'+this.$route.params.primaryMenuLinkId + '/edit')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
